<script>import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, ModalDialog, sidebarCollapsed, stateOpenModal } from "@infinitro/global";
</script>

<button
	class="lucky-dip-button"
	aria-label={$t(Verbiage.button)}
	on:click={() => stateOpenModal.set(ModalDialog.LuckyDip)}
>
	<img
		src={cfgToThemeCdnPath(
			`/sidebar/${$isMobile ? 'dgen-dip-mobile' : $sidebarCollapsed ? 'dgen-dip-collapsed' : 'dgen-dip'}.png`
		)}
		alt={$t(Verbiage.button)}
		class="lucky-dip-image"
		class:lucky-dip-image-collapsed={$sidebarCollapsed}
	/>
</button>

<style>
	.lucky-dip-button {
		width: 100%;
		cursor: pointer;
		border-style: none;
		background-color: transparent;
		padding: 0px;
		outline: 2px solid transparent;
		outline-offset: 2px;
		overflow: hidden;
}

	.lucky-dip-image {
		width: 100%;
		max-width: 100%;
		height: auto;
		display: block;
	}
</style>
